/**
 * Copilot Light Icon - ring icon used for bot avatar.
 */
export function CopilotIcon({ className }: { className?: string }): JSX.Element {
  return (
    <svg 
      width="20" 
      height="20" 
      viewBox="0 0 200 200" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M120.019 25C149.579 25.0002 175.81 39.2514 192.218 61.2578C197.23 73.173 200.001 86.2629 200.001 100C200.001 155.228 155.229 200 100.001 200C58.5489 200 22.9889 174.778 7.82715 138.844C24.2395 160.793 50.4355 175 79.9502 175C107.916 175 132.902 162.244 149.409 142.234C159.129 130.874 165.001 116.123 165.001 100C165.001 64.1018 135.899 35.0005 100.001 35C79.6101 35 61.4124 44.3901 49.4951 59.0811C65.9818 38.3165 91.445 25 120.019 25Z"
        fill="url(#paint0_linear_192_17248)"
      />
      <path
        d="M100 0C141.488 0 177.074 25.2665 192.213 61.251C175.805 39.2483 149.576 25.0002 120.019 25C91.4919 25 66.0662 38.2735 49.5771 58.9795C40.4643 70.1675 35 84.4454 35 100C35 135.899 64.1015 165 100 165C119.776 165 137.488 156.168 149.409 142.234C132.902 162.244 107.916 175 79.9502 175C50.4328 175 24.2344 160.79 7.82227 138.838C2.78506 126.897 0 113.774 0 100C0 44.7715 44.7715 0 100 0Z"
        fill="url(#paint1_linear_192_17248)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_192_17248"
          x1="74.874"
          y1="27.7645"
          x2="99.3959"
          y2="205.445"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3528F7" />
          <stop offset="0.0961538" stopColor="#32259B" />
          <stop offset="0.274038" stopColor="#6534C5" />
          <stop offset="0.786466" stopColor="#A446FA" />
          <stop offset="0.966346" stopColor="#E657FE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_192_17248"
          x1="71.3851"
          y1="7.26779"
          x2="88.2097"
          y2="175.788"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0288462" stopColor="#40FBFB" />
          <stop offset="0.177885" stopColor="#34E2E4" />
          <stop offset="0.653846" stopColor="#2289AD" />
          <stop offset="1" stopColor="#0C1165" />
        </linearGradient>
      </defs>
    </svg>
  );
}
